// extracted by mini-css-extract-plugin
export default {"collisions":"collisions--sAhNB","collisions__item":"collisions__item--soAtl","collisionsItem":"collisions__item--soAtl"};